export default __webpack_public_path__ + "static/media/InstructionForUse.dadf0b35.png";